import React from 'react';
import { observer } from 'mobx-react';

// Helpers
// import { toggleDrawer, toHours } from '../../helpers/helpers.js'
import { toHours } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import PermittedItems from './PermittedItems';

const ExamDetails = observer(class ExamDetails extends React.Component {
  render() {
    const { exam, hideDates, hideType, translation } = this.props;
    const { SessionStore } = this.props.store;
    const { userData, userTimezone } = this.props.store.SessionStore;
    const role = userData.role.toLowerCase();
    let defaultScheduleClose = false;

    let configuration = (exam.examSession && exam.examSession.examConfiguration) ?
      exam.examSession.examConfiguration : exam.configuration;

    let scheduleCloseDate = configuration.scheduleCloseDate;

    if(
      moment(scheduleCloseDate).format('M-D-YYYY') === '1-1-2070' ||
      moment(scheduleCloseDate).diff(moment(configuration.examCloseDate)) >= 0
    ) {
      // If there’s no scheduling window set, use the exam close date
      scheduleCloseDate = configuration.examCloseDate;
      defaultScheduleClose = true;
    }

    let scheduleOpenDate = configuration.scheduleOpenDate;

    if(moment(scheduleOpenDate).format('M-D-YYYY') === '1-1-2000') {
      // If there’s no scheduling window set, use the exam close date
      scheduleOpenDate = configuration.createdDate;
    }

    return (
      <section className="panel__section">
        {!this.props.compact &&
          <h2 className="panel__heading">
            {translation.heading}

            {/* {this.props.examDashboard &&
              <button className="btn--outline" onClick={(e) => {toggleDrawer(e, this.props.parent, 'AddFundingRule')}}>{translation.add_funding_rule}</button>
            } */}
          </h2>
        }

        <ul className={this.props.compact ? 'data--alt' : 'data'}>
          {!hideType &&
            <li>
              <strong className={this.props.compact ? '' : 'strong-bold'}>
                {translation.type}
              </strong>

              { exam.type === ("Online" || "Live Online") ? translation.online_exam : exam.type}
            </li>
          }

          {!hideDates &&
            <li>
              <strong className={this.props.compact ? '' : 'strong-bold'}>
                {translation.opens}
              </strong>

              {moment.utc(configuration.examOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
            </li>
          }

          {!hideDates &&
            <li>
              <strong className={this.props.compact ? '' : 'strong-bold'}>
                {translation.closes}
              </strong>

              {moment.utc(configuration.examCloseDate)
                .tz(userTimezone)
                .format('M/D/YYYY [at] h:mma z')}
            </li>
          }

          <li>
            <strong className={this.props.compact ? '' : 'strong-bold'}>
              {translation.exam_duration}
            </strong>

            {toHours(configuration.duration, false, false, true)}
          </li>

          {!hideDates && this.props.scheduleWindow &&
            <li>
              <strong className={this.props.compact ? '' : 'strong-bold'}>
                {translation.scheduling_opens}
              </strong>

              {moment.utc(scheduleOpenDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
            </li>
          }

          {!hideDates && this.props.scheduleWindow &&
            <li>
              <strong className={this.props.compact ? '' : 'strong-bold'}>
                {translation.scheduling_closes}
              </strong>

              {(!defaultScheduleClose || role !== 'learner') &&
                moment.utc(scheduleCloseDate)
                  .tz(userTimezone)
                  .format('M/D/YYYY [at] h:mma z')
              }

              {defaultScheduleClose && role === 'learner' &&
                moment.utc(scheduleCloseDate)
                  .tz(userTimezone)
                  .format('M/D/YYYY [at] h:mma z')
              }

            </li>
          }

          <PermittedItems
            configuration={configuration}
            listItem={true}
            pushLeft={true}
            dashboardView={true}
            {...this.props}
          />
        </ul>

        {configuration.studentNotes && SessionStore.userData.role.toLowerCase() === 'learner' &&
          <div className="text-block text-block--alt">
            <strong>{translation.notes}:</strong>
            <p>{configuration.studentNotes}</p>
          </div>
        }
      </section>
    )
  }
})

export default translate('ExamDetails')(ExamDetails);



// WEBPACK FOOTER //
// ./src/app/components/Modules/ExamDetails.js